import { ReactNode } from 'react'
import { Control, FieldPath, FieldValues } from 'react-hook-form'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'
import { addPrefixToObject, removePrefix } from '@/utils/prefixer'

import { Label } from './label'

// prettier-ignore
export interface TextareaProps<
  TFieldValues extends FieldValues             = FieldValues,
  TName        extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends
  addPrefixToObject<React.HTMLAttributes<HTMLDivElement>,              'wrapper_'>,
  addPrefixToObject<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'textarea_'>
{
  field_control:      Control<TFieldValues>
  field_name:         TName
  field_label?:       ReactNode
  field_description?: ReactNode
}

const Component = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  field_control,
  field_name,
  field_label,
  field_description,
  ...otherProps
}: TextareaProps<TFieldValues, TName>) => {
  // prettier-ignore
  const prefixedProps = {
  wrapper:  removePrefix<React.HTMLAttributes<HTMLDivElement>>              (otherProps, 'wrapper_'),
  textarea: removePrefix<React.TextareaHTMLAttributes<HTMLTextAreaElement>> (otherProps, 'textarea_'),
}

  return (
    <FormField
      control={field_control}
      name={field_name}
      render={({ field }) => {
        return (
          <FormItem {...prefixedProps.wrapper}>
            {field_label && <Label>{field_label}</Label>}
            <FormControl>
              <Textarea {...field} {...prefixedProps.textarea} />
            </FormControl>
            {field_description && (
              <FormDescription>{field_description}</FormDescription>
            )}
            <FormMessage />
          </FormItem>
        )
      }}
    />
  )
}
Component.displayName = 'Textarea'

export { Component as Textarea }
